import $ from 'jquery';
import eventBus         from 'EventBus.js';
import constants from 'Constants.js';
import BaseTableView from 'properties/BaseTableView.js'
import Template from 'properties/main/ranking.ejs';
import PredefinedListsModal from 'common-views/PredefinedListsModalView.js';
import PredefinedListsService from 'PredefinedListsService';
import NotificationService from 'NotificationService.js';
import RestService from 'RestService.js';
import util from 'util/Util.js';
import _ from 'lodash';
import listService from 'ListService.js';


class MainRankingView extends BaseTableView {


    initialize( opts ) {

        this.options = opts || {};
        this.template = Template;
        this.tagName = 'div';
        this.id = opts.el;
        this.gridEl = constants.PROP_MAIN_TABLE;
        this.config = opts.config || {};
        this.model.set('flag',false,{silent:true});
        this.events = {
            "click .itemNew"              : "itemNew",
            "click .itemRemove"           : "itemRemove",
            "click .itemUp"               : "itemUp",
            "click .itemDown"             : "itemDown",
            "click .itemList" : "itemPredefinedList"
        };
        let self=this;
        this.model.set({
            colModel: [
                {
                    name: 'item',
                    sortable:true,
                    index: 'item',
                    width: 255,
                    editable: true,
                    resizable:false,
                    fixed:false
                }
            ],
            colNames: ['Caption'],
            onSortCol:function (index, iCol,sortorder) {

                let gridData = self.model.get('gridData');
                let list = _.sortBy( gridData, 'item' );
                if(sortorder==='desc'){
                    list.reverse();
                }
                self.model.set('gridData', list);
                self.buildSelectList();
            }
        }, {silent: true});

        if (this.model.get('gridData').length === 0) {
            this.loadDataFromProperty();
        }

        this.listenTo(this.model, 'change', this.render);

        if (!util.hasEventListener(eventBus._events, constants.RESIZE_PROPERTIES_STYLE_PANEL)) {
            this.listenTo(eventBus, constants.RESIZE_PROPERTIES_STYLE_PANEL, util.resizeGridWidth);
        }
        this.onResize();
        return this;
    }
    onResize(){
        $(window).on('resize',() => {this.resizeGrid(); util.makePanelFit();})
    }

    // Method that renders an scroll in the grid in order to navigate the same on small screens.
    resizeGrid(){
        let grid = $('#propMainRanking .ui-jqgrid-btable');
        if (grid) {
            grid.each(function(index) {
                let gridId = $(this).attr('id');
                let gridParentWidth = $('#gbox_' + gridId).parent().width();
                $('#' + gridId).setGridWidth(gridParentWidth);
            });
        }
    }

    loadDataFromProperty() {
        const prop = this.model.get('Property');
        let captions = _.find(prop, function(obj) { return obj._id === 'captions' }) ;
        let ranks = _.find(prop, function(obj) { return obj._id === 'ranks' }) ;

        if (!captions.Item) { captions.Item = []; }
        if (!ranks.Item) { ranks.Item = []; }

        let gridData = [];


        if (Array.isArray(captions.Item)) {
            for (let i = 0; i < captions.Item.length; i++) {

                let newRow = {
                    'item': captions.Item[i]._value,
                    'rank':ranks.Item[i]._value
                };

                gridData.push(newRow);
            }
        } else {
            let newRow = {
                'item': captions.Item._value,
                'rank':ranks.Item._value
            };

            gridData.push(newRow);

            // enforce array type
            const newItem = {_value: captions.Item._value};
            captions.Item = [newItem];

            const newRankItem = {_value: ranks.Item._value};
            ranks.Item = [newRankItem];
        }

        this.model.set('gridData', gridData, {silent: true});
    }

    buildSelectList() {
        let selectFields = [];
        let gridData=this.model.get('gridData');

        _.forEach(gridData, function(i) {
            selectFields.push({
                text: i.item
            })
        });

        this.model.set('selectFields', selectFields, {silent: true});
    }

    fillGrid(elements){
        let gridData=this.model.get('gridData');
        gridData=[];
        Object.keys(elements).forEach((key)=>{
            let newRow = {
                'item':elements[key],
                'rank':key
            };
            gridData.push(newRow);
        });
        this.model.set('gridData', gridData);
    }

    fillGridFromCustomList(elements){
        let gridData=this.model.get('gridData');
        gridData=[];
        elements.forEach((list)=>{
            let newRow = {
                'item':list["@caption"],
                'rank':list["@rank"]
            };
            gridData.push(newRow);
        });
        this.model.set('gridData', gridData);
    }

    itemPredefinedList(event){
        let predModal = new PredefinedListsModal({model: this.model});
        predModal.render().then((selected)=>{
            let items;
            $(constants.PROP_MAIN_TABLE).clearGridData();
            switch (selected){
                case 'countries':
                    items=PredefinedListsService.getCountries();
                    this.fillGrid(items);
                    break;
                case 'states':
                    items=PredefinedListsService.getUSStates();
                    this.fillGrid(items);
                    break;
                case 'provinces':
                    items=PredefinedListsService.getCanadianProvinces();
                    this.fillGrid(items);
                    break;
                default:
                    this.processCustomListItems(selected)
            }
        });
    }

    processCustomListItems(selected){
        RestService.getCustomList(selected).then((customLists)=>{
            let customListsArray=customLists instanceof Array ? customLists : [customLists];
            this.fillGridFromCustomList(customListsArray);
        }).catch((err=>{
            console.log('Error retrieving custom list items ',err);
            NotificationService.error('Error retrieving custom list items '+err.MESSAGE);
        }));
    }

    itemNew(){
        this.model.set('newRowAdded', true, constants.MODEL_SILENT);
        util.saveGridScrollPos(this.model);
        let gridData = this.model.get('gridData');
        let newRow = {
            'item': 'Item ' + (gridData.length + 1),
            'rank': (gridData.length + 1)
        };
        $(constants.PROP_MAIN_TABLE).addRowData((gridData.length), newRow);

        gridData.push(newRow);

        let captions = _.find(this.model.attributes.Property, function(obj) { return obj._id === 'captions' });
        let ranks = _.find(this.model.attributes.Property, function(obj) { return obj._id === 'ranks' });

        captions.Item.push({ _value: 'Item ' + (gridData.length) } );
        ranks.Item.push({ _value: (gridData.length) } );

        this.model.set('gridData', gridData,{silent:true});
        eventBus.trigger('addRankingItemOnList');

        eventBus.trigger(constants.EV_REFRESH_REMOTE_DATA_FILTER);
    }

    afterEditCell(rowId, cellName, value, iRow, iCol) {
        let self=this;
        $("#" + iRow + "_" + cellName).bind('blur', function () {
            $(self.gridEl).saveCell(iRow, iCol);
        });
    }

}

export default MainRankingView;